import isEmpty from 'lodash/isEmpty';
import i18n from '../../../i18n';

export const validate = values => {
    let errors = {};

    message(values, errors);

    return errors;
};

const message = (values, errors) => {
    if (isEmpty(values.message)) {
        return errors.message = i18n.t('followup.error_write_message');
    }
};
